<template>
  <li class="hiw__faqs--question--container">
    <span
      class="hiw__faqs--question"
      @click="toggleAnswer">
      {{ question }}
      <transition name="fade">
        <span
          v-if="answerVisible"
          class="hiw__faqs--answer">{{ answer }}</span>
      </transition>
    </span>
  </li>
</template>

<script>
export default {
  props: {
    question: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      answerVisible: false
    }
  },
  methods: {
    toggleAnswer () {
      this.answerVisible = !this.answerVisible
    }
  }
}
</script>

<style lang="scss" scoped>
#hiw__faqs--section {
  @include section__container;

  ul {
    .hiw__faqs--question--container {
      display: block;
      width: 100%;
      max-width: 600px;
      font-size: 18px;
      padding: 20px 15px 20px 0px;
      border-bottom: 1px solid $grey;

      @media screen and (max-width: 800px) {
        width: 100%;
        margin-right: 0px;
        padding: 20px 0px;
      }

      .hiw__faqs--question {
        cursor: pointer;
        display: block;
        width: 100%;
        position: relative;
        padding-right: 20px;
        font-weight: 700;

        @media screen and (max-width: 800px) {
          font-size: 16px;
        }

        &:after {
          content: "";
          display: inline-block;
          width: 15px;
          height: 15px;
          background-image: url("/img/icon-down-arrow.png");
          background-position: center center;
          background-size: 20px 11px;
          background-repeat: no-repeat;
          position: absolute;
          top: 5px;
          vertical-align: middle;
          right: 0;
        }
      }

      .hiw__faqs--answer {
        margin-top: 18px;
        max-width: 750px;
        line-height: 1.6em;
        font-size: 16px;
        font-weight: 400;
        display: block;

        @media screen and (max-width: 800px) {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
